import logo from 'assets/img/cbg-logo.svg';
import cn from 'classnames';
import BreadcrumbNav from 'components/BreadcrumbNav';
import LangSwitcher from 'components/LangSwitcher';
import useMenu from 'hooks/useMenu';
import React from 'react';
import Menu from '../Menu';
import MenuBtn from '../MenuBtn';
import NavBar from '../NavBar';
import styles from './header.module.scss';

export interface HeaderProps {
  isEmployees: boolean;
  listLangs?: boolean;
  noNav?: boolean;
  languages: string[];
  onLanguageUpdate: (lang: string) => void;
  centerLogo?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  noNav = false,
  isEmployees,
  listLangs = true,
  languages,
  onLanguageUpdate
}) => {
  const { isActive, toggleActive } = useMenu();

  const noNavWithLangs = noNav && listLangs;

  return (
    <div className={cn(styles.root, noNavWithLangs && styles.isSpeakUp)}>
      <div className={styles.top}>
        <div role="banner" className={cn(!noNav && styles.logo)}>
          <img src={logo} alt="carlsberg group logo" />
        </div>
        <div className={cn(styles.options, styles.mobile)}>
          <div className={cn(styles.lang)}>
            <LangSwitcher
              options={languages}
              onLanguageUpdate={onLanguageUpdate}
            />
          </div>

          {!noNav && <MenuBtn active={isActive} toggleActive={toggleActive} />}
        </div>
      </div>
      <>
        <Menu active={isActive}>
          <div
            className={cn(
              styles.nav,
              isEmployees && styles.employeeNav,
              languages?.length > 1 && styles.fullWidth
            )}
          >
            {!noNav &&
              (isEmployees ? (
                <>
                  <div className={styles.employeeBreadcrumb}>
                    <BreadcrumbNav
                      toggleActive={toggleActive}
                      showMobileBack={false}
                    />
                  </div>
                  <div className={styles.employeeMobileNavigation}>
                    <NavBar toggleActive={toggleActive} isEmployees />
                  </div>
                </>
              ) : (
                <NavBar toggleActive={toggleActive} />
              ))}
            {listLangs && (
              <div className={cn(styles.lang, styles.desktop)}>
                <LangSwitcher
                  options={languages}
                  onLanguageUpdate={onLanguageUpdate}
                />
              </div>
            )}
          </div>
        </Menu>
        {!noNav && (
          <div className={styles.mobileHeaderBack}>
            <BreadcrumbNav
              mobileBackOnDark={false}
              showBreadcrumbs={false}
              navigationId={null}
              testId={null}
            />
          </div>
        )}
      </>
    </div>
  );
};

export default Header;
